export default class SteelBarFormOfficialModel{
    Method: string | undefined;
    Capability: string | undefined;
    Resources: string | undefined;
    CompletionDate: string | undefined;
    Subcontracting: string | undefined;
    ConflictOfInterest: boolean | undefined;
    AcceptedBy: string | undefined;
    Date: string | undefined;
    SampleLocation: string | undefined;
    Remarks: string | undefined;
}